import { service } from '@ember/service';
import Route from '@ember/routing/route';
import type ReimaginedDataService from 'tio-employee/services/reimagined-data';

export default class AuthenticatedCareerPathwaysSuccessStoriesRoute extends Route {
  @service declare reimaginedData: ReimaginedDataService;

  async model() {
    const stories = await this.reimaginedData.fetchSuccessStories();
    return { stories };
  }
}
